import type { FormatterFactory } from '../types';
import { gridMessages } from '../../../messages';

export interface BoolOptions {
  trueValue?: string;
  falseValue?: string;
  nullValue?: string;
  trueIfHasValue?: boolean;
  falseIfHasNoValue?: boolean;
}

const TRUTHY = [true, 'true', 'True', 'TRUE', 'yes', 'Yes', 'YES'];
const FALSY = [false, 'false', 'False', 'FALSE', 'no', 'No', 'NO'];

export const bool: FormatterFactory = (options: BoolOptions = {}) => {
  const trueValue = options.trueValue ?? gridMessages.yes;
  const falseValue = options.falseValue ?? gridMessages.no;
  const nullValue = options.nullValue ?? '';

  return {
    toText: (value) => {
      let resolved: any = value;
      if (options.trueIfHasValue) {
        resolved = resolved != null;
      }
      if (options.falseIfHasNoValue) {
        resolved = resolved == null;
      }

      if (TRUTHY.includes(resolved)) {
        return trueValue;
      }
      if (FALSY.includes(resolved)) {
        return falseValue;
      }
      return nullValue;
    },
  };
};
